/**
 * PRODUCT-154 — every export is a `var(--wh-*)` string resolved by `ThemeVars.ts`.
 *
 * Names are UNCHANGED from the pre-conversion module, so the ~330 importers stay
 * untouched and become theme-reactive for free. Real values live in `palette.ts`;
 * consumers that can't take a `var()` string (canvas, mapbox GL paint, JS color
 * math) must read `raw.ts` instead — see the exception inventory in that file.
 */

// --- antd v4 color theme ---

// gray
export const gray100 = 'var(--wh-gray-100)'
export const gray200 = 'var(--wh-gray-200)'
export const gray300 = 'var(--wh-gray-300)'
export const gray400 = 'var(--wh-gray-400)'
export const gray500 = 'var(--wh-gray-500)'
export const gray600 = 'var(--wh-gray-600)'
export const gray700 = 'var(--wh-gray-700)'
export const gray800 = 'var(--wh-gray-800)'
export const gray900 = 'var(--wh-gray-900)'
export const gray1000 = 'var(--wh-gray-1000)'

// red
export const red100 = 'var(--wh-red-100)'
export const red200 = 'var(--wh-red-200)'
export const red300 = 'var(--wh-red-300)'
export const red400 = 'var(--wh-red-400)'
export const red500 = 'var(--wh-red-500)'
export const red600 = 'var(--wh-red-600)'
export const red700 = 'var(--wh-red-700)'
export const red800 = 'var(--wh-red-800)'
export const red900 = 'var(--wh-red-900)'
export const red1000 = 'var(--wh-red-1000)'

// orange
export const orange100 = 'var(--wh-orange-100)'
export const orange200 = 'var(--wh-orange-200)'
export const orange300 = 'var(--wh-orange-300)'
export const orange400 = 'var(--wh-orange-400)'
export const orange500 = 'var(--wh-orange-500)'
export const orange600 = 'var(--wh-orange-600)'
export const orange700 = 'var(--wh-orange-700)'
export const orange800 = 'var(--wh-orange-800)'
export const orange900 = 'var(--wh-orange-900)'
export const orange1000 = 'var(--wh-orange-1000)'

// yellow
export const yellow100 = 'var(--wh-yellow-100)'
export const yellow200 = 'var(--wh-yellow-200)'
export const yellow300 = 'var(--wh-yellow-300)'
export const yellow400 = 'var(--wh-yellow-400)'
export const yellow500 = 'var(--wh-yellow-500)'
export const yellow600 = 'var(--wh-yellow-600)'
export const yellow700 = 'var(--wh-yellow-700)'
export const yellow800 = 'var(--wh-yellow-800)'
export const yellow900 = 'var(--wh-yellow-900)'
export const yellow1000 = 'var(--wh-yellow-1000)'

// green
export const green100 = 'var(--wh-green-100)'
export const green200 = 'var(--wh-green-200)'
export const green300 = 'var(--wh-green-300)'
export const green400 = 'var(--wh-green-400)'
export const green500 = 'var(--wh-green-500)'
export const green600 = 'var(--wh-green-600)'
export const green700 = 'var(--wh-green-700)'
export const green800 = 'var(--wh-green-800)'
export const green900 = 'var(--wh-green-900)'
export const green1000 = 'var(--wh-green-1000)'

// geek blue
export const geekBlue100 = 'var(--wh-geek-blue-100)'
export const geekBlue200 = 'var(--wh-geek-blue-200)'
export const geekBlue300 = 'var(--wh-geek-blue-300)'
export const geekBlue400 = 'var(--wh-geek-blue-400)'
export const geekBlue500 = 'var(--wh-geek-blue-500)'
export const geekBlue600 = 'var(--wh-geek-blue-600)'
export const geekBlue700 = 'var(--wh-geek-blue-700)'
export const geekBlue800 = 'var(--wh-geek-blue-800)'
export const geekBlue900 = 'var(--wh-geek-blue-900)'
export const geekBlue1000 = 'var(--wh-geek-blue-1000)'

// magenta
export const magenta100 = 'var(--wh-magenta-100)'
export const magenta200 = 'var(--wh-magenta-200)'
export const magenta300 = 'var(--wh-magenta-300)'
export const magenta400 = 'var(--wh-magenta-400)'
export const magenta500 = 'var(--wh-magenta-500)'
export const magenta600 = 'var(--wh-magenta-600)'
export const magenta700 = 'var(--wh-magenta-700)'
export const magenta800 = 'var(--wh-magenta-800)'
export const magenta900 = 'var(--wh-magenta-900)'
export const magenta1000 = 'var(--wh-magenta-1000)'

// blue
export const blue100 = 'var(--wh-blue-100)'
export const blue200 = 'var(--wh-blue-200)'
export const blue300 = 'var(--wh-blue-300)'
export const blue400 = 'var(--wh-blue-400)'
export const blue500 = 'var(--wh-blue-500)'
export const blue600 = 'var(--wh-blue-600)'
export const blue700 = 'var(--wh-blue-700)'
export const blue800 = 'var(--wh-blue-800)'
export const blue900 = 'var(--wh-blue-900)'
export const blue1000 = 'var(--wh-blue-1000)'

// volcano
export const volcano100 = 'var(--wh-volcano-100)'
export const volcano200 = 'var(--wh-volcano-200)'
export const volcano300 = 'var(--wh-volcano-300)'
export const volcano400 = 'var(--wh-volcano-400)'
export const volcano500 = 'var(--wh-volcano-500)'
export const volcano600 = 'var(--wh-volcano-600)'
export const volcano700 = 'var(--wh-volcano-700)'
export const volcano800 = 'var(--wh-volcano-800)'
export const volcano900 = 'var(--wh-volcano-900)'
export const volcano1000 = 'var(--wh-volcano-1000)'

// gold
export const gold100 = 'var(--wh-gold-100)'
export const gold200 = 'var(--wh-gold-200)'
export const gold300 = 'var(--wh-gold-300)'
export const gold400 = 'var(--wh-gold-400)'
export const gold500 = 'var(--wh-gold-500)'
export const gold600 = 'var(--wh-gold-600)'
export const gold700 = 'var(--wh-gold-700)'
export const gold800 = 'var(--wh-gold-800)'
export const gold900 = 'var(--wh-gold-900)'
export const gold1000 = 'var(--wh-gold-1000)'

// lyme
export const lime100 = 'var(--wh-lime-100)'
export const lime200 = 'var(--wh-lime-200)'
export const lime300 = 'var(--wh-lime-300)'
export const lime400 = 'var(--wh-lime-400)'
export const lime500 = 'var(--wh-lime-500)'
export const lime600 = 'var(--wh-lime-600)'
export const lime700 = 'var(--wh-lime-700)'
export const lime800 = 'var(--wh-lime-800)'
export const lime900 = 'var(--wh-lime-900)'
export const lime1000 = 'var(--wh-lime-1000)'

// cyan
export const cyan100 = 'var(--wh-cyan-100)'
export const cyan200 = 'var(--wh-cyan-200)'
export const cyan300 = 'var(--wh-cyan-300)'
export const cyan400 = 'var(--wh-cyan-400)'
export const cyan500 = 'var(--wh-cyan-500)'
export const cyan600 = 'var(--wh-cyan-600)'
export const cyan700 = 'var(--wh-cyan-700)'
export const cyan800 = 'var(--wh-cyan-800)'
export const cyan900 = 'var(--wh-cyan-900)'
export const cyan1000 = 'var(--wh-cyan-1000)'

// golden purple
export const purple100 = 'var(--wh-purple-100)'
export const purple200 = 'var(--wh-purple-200)'
export const purple300 = 'var(--wh-purple-300)'
export const purple400 = 'var(--wh-purple-400)'
export const purple500 = 'var(--wh-purple-500)'
export const purple600 = 'var(--wh-purple-600)'
export const purple700 = 'var(--wh-purple-700)'
export const purple800 = 'var(--wh-purple-800)'
export const purple900 = 'var(--wh-purple-900)'
export const purple1000 = 'var(--wh-purple-1000)'

// extra
export const navy900 = 'var(--wh-navy-900)'
export const navy500 = 'var(--wh-navy-500)'
export const navy200 = 'var(--wh-navy-200)'
export const navy100 = 'var(--wh-navy-100)'
export const refaDarkBlue = 'var(--wh-refa-dark-blue)'
export const refaGray = 'var(--wh-refa-gray)'
export const refaLightBlue = 'var(--wh-refa-light-blue)'
export const refaLightGreen = 'var(--wh-refa-light-green)'

// --- tokens ---

// text
export const textPrimary = 'var(--wh-text-primary)'
export const textSecondary = 'var(--wh-text-secondary)'
export const textEmpty = 'var(--wh-text-empty)'
export const textRevPrimary = 'var(--wh-text-rev-primary)'
export const textRevSecondary = 'var(--wh-text-rev-secondary)'
export const textLink = 'var(--wh-text-link)'
export const textDangerous = 'var(--wh-text-dangerous)'

// icon
export const iconPrimary = 'var(--wh-icon-primary)'
export const iconSecondary = 'var(--wh-icon-secondary)'
export const iconLink = 'var(--wh-icon-link)'
export const iconDangerous = 'var(--wh-icon-dangerous)'

// border
export const bSection = 'var(--wh-b-section)'
export const bInputDefault = 'var(--wh-b-input-default)'
export const bInputHover = 'var(--wh-b-input-hover)'

// background
export const bgPage = 'var(--wh-bg-page)'
export const bgSystem = 'var(--wh-bg-system)'
export const bgHeader = 'var(--wh-bg-header)'
export const bgSider = 'var(--wh-bg-sider)'
export const iconHeader = 'var(--wh-icon-header)'
export const bgInnerPrimary = 'var(--wh-bg-inner-primary)'
export const bgInnerSecondary = 'var(--wh-bg-inner-secondary)'
export const bgInnerSubtle = 'var(--wh-bg-inner-subtle)'
export const bgTableHeader = 'var(--wh-bg-table-header)'
export const bgMainTabs = 'var(--wh-bg-main-tabs)'
export const bgCardHeader = 'var(--wh-bg-card-header)'
export const bgOverlay = 'var(--wh-bg-overlay)'
export const bgHover = 'var(--wh-bg-hover)'
export const bgTransp = 'var(--wh-bg-transp)'
export const bgNotificationSection = 'var(--wh-bg-notification-section)'

// feedback
export const fbDefault = 'var(--wh-fb-default)'
export const fbWarning = 'var(--wh-fb-warning)'
export const fbCritical = 'var(--wh-fb-critical)'

// stop status
export const stopCompleted = 'var(--wh-stop-completed)'
export const stopError = 'var(--wh-stop-error)'
export const stopNext = 'var(--wh-stop-next)'

// priority
export const pHigh = 'var(--wh-p-high)'
export const pMedium = 'var(--wh-p-medium)'
export const pLow = 'var(--wh-p-low)'
export const pNone = 'var(--wh-p-none)'

// divider
export const divMain = 'var(--wh-div-main)'
export const divSecondary = 'var(--wh-div-secondary)'
export const divColor = 'var(--wh-div-color)'
